/* eslint-disable no-undef */

function initBaseUrl() {
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
}

function initApiHost() {
  const scheme = isProduction ? 'https' : 'http';
  const name = isProduction ? productionApiDomain : window.location.hostname;
  const port = isProduction ? '443' : '8080';
  const baseUrl = isProduction ? `//${name}` : `//${name}:${port}`;

  return {
    name,
    port,
    scheme,
    baseUrl,
  };
}

const productionBaseDomain = 'menur.app';
const productionFullDomain = `azure.${productionBaseDomain}`;
const productionApiDomain = `api.${productionFullDomain}`;
const isProduction = window.location.hostname.includes(productionBaseDomain);

// const isProduction = true;
const apiHost = initApiHost();
const baseUrl = initBaseUrl();
const subdomain = window.location.host.split('.')[0];
console.log('subdomain', subdomain);

// const isDelivery = ['delivery'].includes(subdomain);
const isDelivery = ['delivery', 'zycmacbook'].includes(subdomain);

const isDevEnv = !isProduction;

export { apiHost, baseUrl, isDelivery, isDevEnv };
